import { Input } from 'antd';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from '../../Users.module.css';

interface NewUserAssociatedProductsAndProcessesInputProps {
  data: string[];
  disabled: boolean;
  fieldName: string;
}

const { TextArea } = Input;

export const NewUserAssociatedProductsAndProcessesInput: React.FC<
  NewUserAssociatedProductsAndProcessesInputProps
> = ({ data, disabled, fieldName }) => {
  const { t } = useTranslation();
  const joinedData = data.join('\n');
  return (
    <Form.Item
      label={
        fieldName === 'associatedProcesses'
          ? t(`edit-user-form.associated-processes`)
          : t(`edit-user-form.associated-products`)
      }
      className={styles.userFormInputTitle}
    >
      <TextArea
        style={{ resize: 'none' }}
        rows={4}
        disabled={disabled}
        value={joinedData}
      />
    </Form.Item>
  );
};
